module.exports = __webpack_public_path__ + "static/media/Scotiabank.a82fe06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/Scotiabank.png
// module id = 1987
// module chunks = 0